import FormComponent from '../../../../components/FormComponent';

class RegistrationLegalConfirm extends FormComponent {
	markup(_value, data = {}, titleMarkup) {
		const {
			introText = 'By submitting this registration form you are confirming that:',
			items = [],
			footerHtml = '',
			spacingClass = 'u-mb-5'
		} = data;

		const itemsMarkup = (items || [])
			.map((item) => `<li class="u-body1">${item}</li>`)
			.join('');

		return `
			<div class="lta-registration-legal-confirm ${spacingClass}">
				${titleMarkup}
				${introText ? `<p class="u-body1 u-mb-3">${introText}</p>` : ''}
				${itemsMarkup ? `<ul class="u-pl-3 u-mb-0">${itemsMarkup}</ul>` : ''}
				${
					footerHtml
						? `<p class="u-body1 u-mt-3">${footerHtml}</p>`
						: ''
				}
			</div>
		`;
	}

	validate() {
		return true;
	}

	getValueFromElement() {
		return true;
	}
}

export default RegistrationLegalConfirm;
